$(document).ready(
    function () {
      
          // AJOUTER PRODUIT VARIANT AU PANIER
          $('#product-variants label').on( 'click', function() {
              setTimeout(
                function() {
                  const queryString = window.location.search;

                  const urlParams = new URLSearchParams(queryString);
                  const variant = urlParams.get('variant');

                  $('#product-variants .variant-cart').remove();
                  $('#product-variants').append('<input class="variant-cart" type="hidden" name="id" value="' + variant + '" />');

                  // PRICE

                  let variant_price = $(".valeures[variant-id=" + variant + "]").attr("price");
                  let variant_compare = $(".valeures[variant-id=" + variant + "]").attr("compare");
                  
                  let nom_produit = $(".valeures[variant-id=" + variant + "]").attr("option3").replace("Pack", '');
                  let nom_produit2 = '<span style="color:#2B2B2B;">Pack </span>' + nom_produit + '';
				  var offre_marketing = $(".variant-selected h4").text().replace("GRATUITES", '<span class="color_offertes">GRATUITES</span>');
           
                  
                  $('.images_du_produit .nom_produit').html(nom_produit2);
                  $('.images_du_produit .offre_marketing').html(offre_marketing);


                  $('.produit .description_produit .prix, .personnalisez_votre_pack .price_bouton .price .prix, .bottom_bar .bottom_bar_produit .price .prix').text(variant_price);
                  $('.produit .description_produit .compare, .personnalisez_votre_pack .price_bouton .price .compare, .bottom_bar .bottom_bar_produit .price .compare').text(variant_compare);
                  
                  var src_img_variant2 = $('.valeures[variant-id="' + variant + '"]').attr('variant-img-src');
          		  
                  $(".bottom_bar .img_bottom_bar, .images_du_produit img").attr('src', src_img_variant2);
                  
                  
                }, (50));
           });
      
      
      
      
      
      	// CLICK PACK 3
      	$('.form_etapes_produit .pack_3_paires').on( 'click', function() {
          
          $('.form_etapes_produit .pack_6_paires').removeClass("variant-selected");
          $(this).addClass("variant-selected");
          $('.vos-modeles .pack_1').css({'display' : 'flex'});
          $('.vos-modeles .pack_0').css({'display' : 'none'});
          
          $('.bottom_bar .modeles option.pack_1').css({'display' : 'block'});
          $('.bottom_bar .modeles option.pack_0').css({'display' : 'none'});
          
          $('.votre-pack .votre-pack-1').trigger('click');
          $('.vos-modeles .pack_1:first').trigger('click');
          $('.bottom_bar .variants_produit .pack select option:eq(1)').prop('selected', true);
      	});
      
      	// FAQ
        $('.faq .question-reponse .question').on( 'click', function() {
            if($(this).siblings("p").css('display') == 'none'){            
                $(this).siblings("p").css({'display': 'block'});
                $(this).children("svg").css({'transform': 'rotate(180deg)'});
            } else {
                $(this).siblings("p").css({'display': 'none'});
                $(this).children("svg").css({'transform': 'rotate(0deg)'});
            }
            
          });
      
                                                    
                                                    
        // CLICK PACK 6
      	$('.form_etapes_produit .pack_6_paires').on( 'click', function() {
          
          $('.form_etapes_produit .pack_3_paires').removeClass("variant-selected");
          $(this).addClass("variant-selected");
          $('.vos-modeles .pack_0').css({'display' : 'flex'});
          $('.vos-modeles .pack_1').css({'display' : 'none'});
          
          $('.bottom_bar .modeles option.pack_0').css({'display' : 'block'});
          $('.bottom_bar .modeles option.pack_1').css({'display' : 'none'});
          
          $('.votre-pack .votre-pack-0').trigger('click');
          $('.vos-modeles .pack_0:first').trigger('click');
          $('.bottom_bar .variants_produit .pack select option:eq(0)').prop('selected', true);
      	});   
      
      
 		$(".pack_3_paires select")
          .change(function() {
            var str = "";
            $(".pack_3_paires select option:selected").each(function() {
              str += this.className;
            });
          	$('.votre-taille .votre-taille-'+ str +'').trigger('click');
          	$('.pack_6_paires select option:eq('+ str +')').prop('selected', true);
          	$('.bottom_bar .variants_produit .taille select option:eq('+ str +')').prop('selected', true);
          })
          .trigger("change");
      
      
      $(".pack_6_paires select")
          .change(function() {
            var str = "";
            $(".pack_6_paires select option:selected").each(function() {
              str += this.className;
            });
          	$('.votre-taille .votre-taille-'+ str +'').trigger('click');
          	$('.pack_3_paires select option:eq('+ str +')').prop('selected', true);
        	$('.bottom_bar .variants_produit .taille select option:eq('+ str +')').prop('selected', true);
          })
          .trigger("change");
      
      
      // BOTTOM BAR ADD TO CART
      $('.bottom_bar .bouton').on( 'click', function() {
      	$('#add_to_cart').trigger('click');
      });
      
      
      // BOTTOM BAR TAILLE SELECT
      $(".bottom_bar .variants_produit .taille select")
          .change(function() {
            var str = "";
            $(".bottom_bar .variants_produit .taille select option:selected").each(function() {
              str += this.className;
            });
          	$('.votre-taille .votre-taille-'+ str +'').trigger('click');
          	$('.pack_3_paires select option:eq('+ str +')').prop('selected', true);
        	$('.pack_6_paires select option:eq('+ str +')').prop('selected', true);
          })
          .trigger("change");
      

      // BOTTOM BAR MODELES SELECT
      $(".bottom_bar .variants_produit .modeles select")
          .change(function() {
            var str = "";
            $(".bottom_bar .variants_produit .modeles select option:selected").each(function() {
              str += this.className.replace("pack_1", "").replace("pack_0", "").replace("o", "");
            });
          	$('.vos-modeles .vos-modeles-'+ str +'').trigger('click');
          })
          .trigger("change");
      
      
      // BOTTOM BAR PACK SELECT
      $(".bottom_bar .variants_produit .pack select")
          .change(function() {
            var str = "";
            $(".bottom_bar .variants_produit .pack select option:selected").each(function() {
              str += this.className;
            });
        	if(str == 0){
        		$('.form_etapes_produit .pack_6_paires').trigger('click');
        	}
        	if(str == 1){
        		$('.form_etapes_produit .pack_3_paires').trigger('click');
        	}
          })
          .trigger("change");
      
      
      	// CLICK LABEL MODÈLES
      	$('#product-variants .vos-modeles label').on( 'click', function() {
          var className = $(this).attr('class').replace("vos-modeles-", "").replace("pack_0", "").replace("pack_1", "");
          $('.bottom_bar .variants_produit .modeles select option:eq(' + className + ')').prop('selected', true);
          
      	});
      
      
                                   
      
      
      	if ($('#slidecarthq .cart-count').is(':empty')){
          	$('#slidecarthq .cart-count').text('0');
        }

        var width_screen = $(window).width();
        // MOBILE
        if (width_screen <= 900) {
          
          var infos_produit = $(".description_produit .infos_produit").html();
          $(".description_produit .infos_produit").remove();
          $("<ul class=\"infos_produit\">" + infos_produit + "</ul>").insertAfter(".form_etapes_produit");
          
          
            // BAR D'ANNONCES
              if ( $("#announcement_bar").length ){
                	var header_height = $(".le_header").outerHeight();
                	var announcement_height = $("#announcement_bar").outerHeight();
                    $('.le_header').css({'top' : announcement_height});
                    $('#menuToggle').css({'top' : 'calc(' + announcement_height+ 'px + 25px)'});
                    if ( $(".cart-count-bubble").length ){
						$('#panier_mobile').css({'top' : 'calc(' + announcement_height+ 'px + 25px)'});
                    } else {
                    	$('#panier_mobile').css({'top' : 'calc(' + announcement_height+ 'px + 20px)'});
                    }
                    $('#MainContent, .faq ').css({'padding-top' : announcement_height});
              }
          
          
           	$('.jdgm-carousel-wrapper').append('<div class="fleches"><svg class="left-arrow" width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><circle r="24.5" transform="matrix(-1 0 0 1 25 25)" stroke="#9C9C9C"/><g clip-path="url(#clip0_28:264)"><path d="M33.8511 26.9605L18.9317 26.9605L22.9622 30.8943C23.412 31.3333 23.4137 32.0468 22.9661 32.4879C22.5185 32.929 21.791 32.9306 21.3412 32.4917L15.338 26.6323L15.337 26.6313C14.8884 26.1923 14.887 25.4765 15.3369 25.036L15.3379 25.035L21.3411 19.1756C21.7908 18.7367 22.5183 18.7382 22.966 19.1794C23.4136 19.6205 23.4118 20.3339 22.9621 20.773L18.9317 24.7068L33.8511 24.7068C34.4857 24.7068 35 25.2113 35 25.8336C35 26.456 34.4857 26.9605 33.8511 26.9605Z" fill="#9C9C9C"/></g><defs><clipPath id="clip0_28:264"><rect width="20" height="15" fill="white" transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 15 33.3335)"/></clipPath></defs></svg><svg class="right-arrow" width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="25" cy="25" r="24.5" stroke="#9C9C9C"/><g clip-path="url(#clip0_28:264)"><path d="M16.1489 26.9605L31.0683 26.9605L27.0378 30.8943C26.588 31.3333 26.5863 32.0468 27.0339 32.4879C27.4815 32.929 28.209 32.9306 28.6588 32.4917L34.662 26.6323L34.663 26.6313C35.1116 26.1923 35.113 25.4765 34.6631 25.036L34.6621 25.035L28.6589 19.1756C28.2092 18.7367 27.4817 18.7382 27.034 19.1794C26.5864 19.6205 26.5882 20.3339 27.0379 20.773L31.0683 24.7068L16.1489 24.7068C15.5143 24.7068 15 25.2113 15 25.8336C15 26.456 15.5143 26.9605 16.1489 26.9605Z" fill="#9C9C9C"/></g><defs><clipPath id="clip0_28:264"><rect width="20" height="15" fill="white" transform="translate(35 33.3335) rotate(-180)"/></clipPath></defs></svg></div>');

          
            $('.carousel_liste_produits').flickity({
                cellAlign: 'center',
                prevNextButtons: false,
                wrapAround: true,
                autoPlay: 5000,
                dragThreshold: 10,
                adaptiveHeight: true
            });

            var $carousel_avis = $('.carousel_avis_clients').flickity({
                cellAlign: 'center',
                prevNextButtons: false,
                wrapAround: true,
                autoPlay: 5000,
                adaptiveHeight: true,
            	imagesLoaded: true
            });


            $( ".idees_recues .carousel_idees_recues .bouton_idees_recues" ).remove();


            // IDÉES REÇUES
            var $carousel_idees = $('.carousel_idees_recues').flickity({
                cellAlign: 'center',
                prevNextButtons: false,
                wrapAround: true,
                autoPlay: 8000,
                adaptiveHeight: true
            });



            // AVIS PAGE PRODUIT
            var $carousel_produit = $('#avis_produit .les_avis_clients').flickity({
                cellAlign: 'center',
                prevNextButtons: false,
                wrapAround: true,
                autoPlay: 8000,
                adaptiveHeight: true
            });


            // FLÈCHES AVIS
            $('.arrow-avis-left').on( 'click', function() {
                $carousel_produit.flickity( 'previous', true );
            });

            $('.arrow-avis-right').on( 'click', function() {
                $carousel_produit.flickity( 'next', true );
            });


                // MENU DIV OPACITY
                $('#box').on( 'click', function() {

                    if ($('#box').is(':checked')) {
                        $('<div id="div_opacity_30"></div>').insertAfter('#panier_mobile');
                        setTimeout(
                            function() {
                                $('#div_opacity_30').css({
                                    'opacity' : '0.3'
                                });
                            }, (50)
                        );
                    }else{
                        $('#div_opacity_30').css({
                            'opacity' : '0'
                        });
                        setTimeout(
                            function() {
                                $( "#div_opacity_30" ).remove();
                            }, (1500)
                        );
                    }



                    
                });

        }
        // DESKTOP
        else {
          
          	if ( $("#announcement_bar").length ){
                $('.le_header').css({'top' : '30px'});
                $('#MainContent').css({'padding-top' : '30px'});
            	$('#menu_produits').css({'top' : '57px'});
            	$('#menu_right').css({'top' : '57px'});
          	}
          
          	$('.jdgm-carousel-wrapper .jdgm-carousel-title-and-link').append('<div class="fleches"><svg class="left-arrow" width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><circle r="24.5" transform="matrix(-1 0 0 1 25 25)" stroke="#9C9C9C"/><g clip-path="url(#clip0_28:264)"><path d="M33.8511 26.9605L18.9317 26.9605L22.9622 30.8943C23.412 31.3333 23.4137 32.0468 22.9661 32.4879C22.5185 32.929 21.791 32.9306 21.3412 32.4917L15.338 26.6323L15.337 26.6313C14.8884 26.1923 14.887 25.4765 15.3369 25.036L15.3379 25.035L21.3411 19.1756C21.7908 18.7367 22.5183 18.7382 22.966 19.1794C23.4136 19.6205 23.4118 20.3339 22.9621 20.773L18.9317 24.7068L33.8511 24.7068C34.4857 24.7068 35 25.2113 35 25.8336C35 26.456 34.4857 26.9605 33.8511 26.9605Z" fill="#9C9C9C"/></g><defs><clipPath id="clip0_28:264"><rect width="20" height="15" fill="white" transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 15 33.3335)"/></clipPath></defs></svg><svg class="right-arrow" width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="25" cy="25" r="24.5" stroke="#9C9C9C"/><g clip-path="url(#clip0_28:264)"><path d="M16.1489 26.9605L31.0683 26.9605L27.0378 30.8943C26.588 31.3333 26.5863 32.0468 27.0339 32.4879C27.4815 32.929 28.209 32.9306 28.6588 32.4917L34.662 26.6323L34.663 26.6313C35.1116 26.1923 35.113 25.4765 34.6631 25.036L34.6621 25.035L28.6589 19.1756C28.2092 18.7367 27.4817 18.7382 27.034 19.1794C26.5864 19.6205 26.5882 20.3339 27.0379 20.773L31.0683 24.7068L16.1489 24.7068C15.5143 24.7068 15 25.2113 15 25.8336C15 26.456 15.5143 26.9605 16.1489 26.9605Z" fill="#9C9C9C"/></g><defs><clipPath id="clip0_28:264"><rect width="20" height="15" fill="white" transform="translate(35 33.3335) rotate(-180)"/></clipPath></defs></svg></div>');

            var $carousel_avis = $('.carousel_avis_clients').flickity({
                cellAlign: 'center',
                prevNextButtons: false,
                wrapAround: true,
                autoPlay: 10000,
                groupCells: 3,
                pageDots: false,
                selectedAttraction: 0.013,
                adaptiveHeight: true,
            	imagesLoaded: true
            });

            setTimeout(
                function() {
                    $('.avis_clients ul li').css({
                        'width' : 'calc(33.33% - 93.33px)'});
                }, (200)
            );

            // 
            $(window).scroll(function() {
                var top_of_element = $(".newsletter").offset().top;
                var bottom_of_element = $(".newsletter").offset().top + $(".newsletter").outerHeight();
                var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
                var top_of_screen = $(window).scrollTop();
    
                if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)){
                    $('.bottom_bar').css({'bottom' : '-110px', 'transition' : 'bottom 1s cubic-bezier(.7,.01,.27,.99)'});
                }
            });

            // PANIER SE FERME
            $('#panier .header_panier .cross').on( 'click', function() {
                $('#panier').css({
                    'right' : '-480px',
                    'box-shadow' : '-13px 0px 40px 0px rgb(43 43 43 / 0%)'
                });
                $('#div_opacity_30').css({
                    'opacity' : '0'
                });
                setTimeout(
                    function() {
                        $( "#div_opacity_30" ).remove();
                    }, (1500)
                );
            });
        }

        var $carousel_home = $('.home_slider').flickity({
            cellAlign: 'left',
            prevNextButtons: false,
            wrapAround: true,
            groupCells: 1,
            draggable: false,
            pageDots: false,
            adaptiveHeight: true
        });


        // FLÈCHES HOME SLIDER
        $('.home_slider .slider_1 .fleche_gauche, .home_slider .slider_2 .fleche_gauche, .home_slider .slider_3 .fleche_gauche').on( 'click', function() {
            $carousel_home.flickity( 'previous', true );
        });

        $('.home_slider .slider_1 .fleche_droite, .home_slider .slider_2 .fleche_droite, .home_slider .slider_3 .fleche_droite').on( 'click', function() {
            $carousel_home.flickity('next');
        });




        // FLÈCHES AVIS
        $('.arrow-avis-left').on( 'click', function() {
            $carousel_avis.flickity( 'previous', true );
          });

        $('.arrow-avis-right').on( 'click', function() {
            $carousel_avis.flickity( 'next', true );
        });
      
      	
      	// SLIDER IMAGES RIGHT
        $('.images_du_produit .slider_arrows svg.right_arrow').on( 'click', function() {
          	var nombre_labels = $(".vos-modeles label.pack_0").length - 1;
          	var nombre_labels_1 = $(".vos-modeles .pack_1").length + nombre_labels;
          
        	if( $(".pack_6_paires").hasClass("variant-selected") ){
              	var numero_label_selectionne = $('.vos-modeles input[type="radio"]:checked+label').attr('class').replace('pack_0','').replace('vos-modeles-','');
              	if (numero_label_selectionne == nombre_labels){
                  	$('#product-variants .vos-modeles .pack_0').eq(0).trigger('click');
                } else {
                  	var le_bon_num = parseInt(numero_label_selectionne) + 1;
                	$('#product-variants .vos-modeles .pack_0').eq(le_bon_num).trigger('click');
                }
            }
          
          	if( $(".pack_3_paires").hasClass("variant-selected") ){
              	var numero_label_selectionne = $('.vos-modeles input[type="radio"]:checked+label').attr('class').replace('pack_1','').replace('vos-modeles-','');
              	if (numero_label_selectionne == nombre_labels_1){
                  	$('#product-variants .vos-modeles .pack_1').eq(0).trigger('click');
                } else {
                  	var le_bon_num = parseInt(numero_label_selectionne) + 1;
                	$('#product-variants .vos-modeles label').eq(le_bon_num).trigger('click');
                }
            }
        });
      
      
      	// SLIDER IMAGES LEFT
        $('.images_du_produit .slider_arrows svg.left_arrow').on( 'click', function() {
          	var nombre_labels = $(".vos-modeles label.pack_0").length - 1;
          	var nombre_labels_1 = $(".vos-modeles .pack_1").length + nombre_labels;
          	var nombre_labels_2 = $(".vos-modeles .pack_1").length;
          
        	if( $(".pack_6_paires").hasClass("variant-selected") ){
              	var numero_label_selectionne = $('.vos-modeles input[type="radio"]:checked+label').attr('class').replace('pack_0','').replace('vos-modeles-','');
              	if (numero_label_selectionne == 0){
                  $('#product-variants .vos-modeles .pack_0:last').trigger('click');
                } else {
                  	var le_bon_num = parseInt(numero_label_selectionne) - 1;
                	$('#product-variants .vos-modeles .pack_0').eq(le_bon_num).trigger('click');
                }
            }
          
          	if( $(".pack_3_paires").hasClass("variant-selected") ){
              	var numero_label_selectionne = $('.vos-modeles input[type="radio"]:checked+label').attr('class').replace('pack_1','').replace('vos-modeles-','');
              	console.log(numero_label_selectionne+ "et" +nombre_labels_1);
              	console.log(nombre_labels);
              	console.log(nombre_labels_1);
              console.log(nombre_labels_2);
              	if (numero_label_selectionne == nombre_labels + 1){
                  $('#product-variants .vos-modeles .pack_1:last').trigger('click');
                } else {
                  	var le_bon_num = parseInt(numero_label_selectionne) - 1;
                	$('#product-variants .vos-modeles label').eq(le_bon_num).trigger('click');
                }
            }

        });



        // CLICK BOUTON ÉTAPE 1
        $('#produit_etape_suivante, #etape_2').on( 'click', function() {
            $('.produit .personnalisez_votre_pack .form_etapes_produit').css({
                'transform' : 'translateX(calc(-50% - 20px))'
            });
            $('.produit .personnalisez_votre_pack .boutons_etapes_produit #etape_1').css({
                '-moz-animation' : 'none',
                '-webkit-animation' : 'none',
                'animation' : 'none'
            });

            $('.produit .personnalisez_votre_pack .boutons_etapes_produit .divider1').css({
                'clip-path' : 'inset(0px 0% 0px 0px)'
            });

            setTimeout(
                function() {
                    $('.produit .personnalisez_votre_pack .boutons_etapes_produit #etape_2').css({
                        'font-weight' : '600',
                        'color' : '#FFF',
                        'opacity' : '1',
                        '-moz-animation' : 'clignote 1.5s infinite',
                        '-webkit-animation' : 'clignote 1.5s infinite',
                        'animation' : 'clignote 1.5s infinite'
                    });
                }, (975)
            );
        });

        $('#etape_1').on( 'click', function() {
            $('.produit .personnalisez_votre_pack .form_etapes_produit').css({
                'transform' : 'translateX(0%)'
            });
            $('.produit .personnalisez_votre_pack .boutons_etapes_produit #etape_1').css({
                '-moz-animation' : 'clignote 1.5s infinite',
                '-webkit-animation' : 'clignote 1.5s infinite',
                'animation' : 'clignote 1.5s infinite'
            });
            $('.produit .personnalisez_votre_pack .boutons_etapes_produit #etape_2').css({
                'background-color' : 'unset',
                'font-weight' : '400',
                'color' : '#2B2B2B',
                'opacity' : '.5',
                'border' : '1px solid #2B2B2B',
                '-moz-animation' : 'none',
                '-webkit-animation' : 'none',
                'animation' : 'none'
            });
            $('.produit .personnalisez_votre_pack .boutons_etapes_produit .divider1').css({
                'clip-path' : 'inset(0px 100% 0px 0px)'
            });
        });
      
      $('.fleches .left-arrow').click(function(e){
                $('.jdgm-carousel-wrapper .jdgm-carousel__arrows .jdgm-carousel__left-arrow').trigger('click');
            });
          
          	$('.fleches .right-arrow').click(function(e){
                $('.jdgm-carousel-wrapper .jdgm-carousel__arrows .jdgm-carousel__right-arrow').trigger('click');
            });


        $(document).on('scroll', function () {
            var scrollTop = $(document).scrollTop(),
            pourcentage = "0.01",
            windowHeight = $(window).height() * pourcentage;
            height_1section_produit = $(".produit").outerHeight();
            
            if ($(window).scrollTop() > windowHeight){
                $('header').css({'box-shadow' : '0px 13px 40px 0px rgb(43 43 43 / 7%)'});
            } else {
                $('header').css({'box-shadow' : '0px 13px 40px 0px rgb(43 43 43 / 0%)'});
            }

            if ($(window).scrollTop() > height_1section_produit){
                $('.bottom_bar').css({'bottom' : '0px', 'transition' : 'bottom 1s cubic-bezier(.7,.01,.27,.99)'});
            } else {
                $('.bottom_bar').css({'bottom' : '-110px', 'transition' : 'bottom 1s cubic-bezier(.7,.01,.27,.99)'});
            }
        });
      
      
      setTimeout(
        function() {
          $('#product-variants .vos-modeles .pack_0').eq(1).trigger('click');
          $('#product-variants .vos-modeles .pack_0').eq(0).trigger('click');
        }, (100));
      
      
    if ($('.vos-modeles .pack_1').length == 0){
            $('.form_etapes_produit .pack_3_paires').css({'display' : 'none'});
          }

    }
)
